module.exports = {"StatusCode":200,"Payload":"[[\"server-1\",\"server-2\",\"server-3\",\"server-4\"]]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/checkNameServers.json
// module id = uCU7
// module chunks = 0